module.exports = "/images/vendor/desiigner-svg/svg/places/truck.svg?deacc849e36e749aa8178b5a3ffcf96e";